<template>
  <div class="editcustomroom-container modal-overlay" @click="$emit('close')">
    <div class="content modal-content" @click.stop>
      <img :src="customRoom.url" ref="photo"/>

      <div v-if="showRemove" class="confirm" @click="remove()">
        <i v-if="deletionInProgress" class="fas fa-circle-notch fa-spin"/>
        <template v-else>Delete</template>
      </div>
      <div v-else-if="showRotate" class="confirm" @click="rotate()">
        <i v-if="rotationInProgress" class="fas fa-circle-notch fa-spin"/>
        <template v-else>Save</template>
      </div>

      <div class="icons">
        <div class="icon remove" @click="previewRemove()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:none;stroke-linejoin:round;stroke-width:2;stroke:currentColor"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
          <br/>
          Remove
        </div>
        <div class="icon rotate" @click="previewRotate()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:none;stroke-linejoin:round;stroke-width:2;stroke:currentColor"><polyline points="23 4 23 10 17 10"/><path d="M20.5 15a9 9 0 1 1-2.1-9.4L23 10"/></svg>
          <br/>
          Rotate
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileUploadService from '@/services/file-upload-service.js'

export default {
  name: 'EditCustomRoom',
  props: {
    customRoom: {
      type: Object,
      required: true
    },
    project: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showRemove: false,
      showRotate: false,

      rotation: 0,

      deletionInProgress: false,
      rotationInProgress: false,
    }
  },
  methods: {
    previewRemove() {
      this.showRotate = false
      this.showRemove = !this.showRemove
    },
    previewRotate() {
      this.showRemove = false

      let r = this.$refs.photo

      let currRot = r.style.transform
      let nextRot = 0
      if(currRot == '' || currRot == 'rotate(0deg)') {
        nextRot = 90
      }
      if(currRot == 'rotate(90deg)') {
        nextRot = 180
      }
      if(currRot == 'rotate(180deg)') {
        nextRot = 270
      }

      r.style.transform = 'rotate(' + nextRot + 'deg)'

      this.rotation = nextRot
      
      if(nextRot != 0) {
        this.showRotate = true
      } else {
        this.showRotate = false
      }
    },
    async remove() {
      this.deletionInProgress = true
      await fileUploadService.deleteCustomRoom(this.project, this.filename(this.customRoom.name))
      // console.log("deleting", this.filename(n))
      this.deletionInProgress = false
      
      this.$emit('deletion-complete')
      this.$emit('close')
    },
    async rotate() {
      if(this.rotationInProgress)
        return
      
      if(this.rotation == 0)
        return

      let rotation = this.rotation
      // backend library uses counter clockwise, css clockwise rotation
      if(rotation == 90) { 
        rotation = 270
      }
      else if(rotation == 270) {
        rotation = 90
      }

      this.rotationInProgress = true
      await fileUploadService.rotateCustomRoom(this.project, this.filename(this.customRoom.name), rotation)
      this.rotationInProgress = false

      this.$emit('rotate-complete', this.customRoom.name)
      this.$emit('close')
    },
    filename(s) {
      return s.split('/').pop()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.content {
  max-width: 90vw;
  height: 90vh;
  overflow: hidden;
  position: relative;
  background-color: rgb(41, 41, 41);

  img {
    max-height: 100%;
    max-width: 100%;
    display: block;
    margin: auto;
  }

  &:hover {
      .icons {
        opacity: 1;
      }
    }
}

.icons {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5px;
  text-align: center;
  z-index: 2;
  background-color: rgba(white, 1);
  opacity: 0;
  transition: 0.2s opacity;
  padding: 20px;
  font-size: 14px;

  .icon {
    display: inline-block;
    cursor: pointer;
    margin-left: 5px;
    transition: 0.1s all;
    margin: 10px;
  }

  .rotate {
    &:hover {
      color: $green;
    }
  }

  .remove {
    &:hover {
      color: $red;
    }
  }
}

.confirm {
  padding: 10px 20px;
  position: absolute;
  border-radius: $border-radius;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba($secondary, 0.7);
  color: white;
  cursor: pointer;
  transition: 0.2s all;

  &:hover {
    background-color: rgba($secondary, 1);
  }
}
</style>